/* -------------------------------------------------------------------------- */
/*                      Componente SlidingPaneDowntimeReasons                 */
/* -------------------------------------------------------------------------- */
// Este componente permite visualizar razones de tiempo de inactividad

import * as alerts from '@redux/utils/alerts';
import { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import SlidingPane from 'react-sliding-pane';
import { appIntl } from 'utility/context/IntlGlobalProvider';
import { TableColumn } from 'utility/types';
import AddButton from 'views/components/AddButton';
import DeleteButton from 'views/components/DeleteButton';
import EditButton from 'views/components/EditButton';
import Table from 'views/components/Table';
import Toolbar from 'views/components/Toolbar';
import SlidingPaneAddEditDowntimeReason from 'views/formComponents/SlidingPaneAddEditDowntimeReason';
import * as organizationActions from 'views/screens/Organizations/actions';
import useGetDowntimeReasons from 'views/screens/Organizations/hooks/useGetDowntimeReasons';
import * as organizationSelectors from 'views/screens/Organizations/reducers';
import unitPermissions from 'views/screens/TrackingUnits/permissions';

const columnInfo: TableColumn[] = [
  {
    fieldName: 'reasonId',
    headerText: 'common.id'
  },
  {
    fieldName: 'reasonDescription',
    headerText: 'organizations.reason'
  }
];

interface Props {
  organization: any;
  isOpenSlidingPane: any;
  closeSlidingPaneDowntimeReasons: any;
  width?: string;
}

const SlidingPaneDowntimeReasons = (props: Props) => {
  const { organization, isOpenSlidingPane, closeSlidingPaneDowntimeReasons, width } = props;
  const intl = useIntl();
  const dispatch = useDispatch();

  const [selected, changeSelected] = useState<any[]>([]);
  const [addEditDowntimeReasonSlideOpen, openAddEditDowntimeReasonSlide] = useState(false);
  const [executeGetDowntimeReasons, setExecuteGetDowntimeReasons] = useState(false);

  const { isOperating } = useSelector((state) => ({
    isOperating:
      organizationSelectors.isRemovingOrganizationDowntimeReason(state) ||
      organizationSelectors.isEditingOrganizationDowntimeReason(state) ||
      organizationSelectors.isAddingOrganizationDowntimeReason(state)
  }));

  //HOOK PARA OBTENER LAS RAZONES DE DOWNTIME
  const { downtimeReasons, isFetchingDowntimeReasons } = useGetDowntimeReasons(
    organization?.organizationId,
    executeGetDowntimeReasons
  );

  useEffect(() => {
    isOperating === false && isFetchingDowntimeReasons === false
      ? setExecuteGetDowntimeReasons(!executeGetDowntimeReasons)
      : '';
  }, [isOperating]);

  useEffect(() => {
    organization?.organizationId !== undefined
      ? setExecuteGetDowntimeReasons(!executeGetDowntimeReasons)
      : '';
  }, [organization?.organizationId]);

  return organization !== undefined && organization !== null ? (
    <SlidingPane
      className="custom-sliding-pane"
      overlayClassName="custom-overlay-sliding-pane"
      isOpen={isOpenSlidingPane}
      title={intl.formatMessage({
        id: 'organizations.downtimeReasons'
      })}
      subtitle={organization?.organizationName}
      width={width ?? '35rem'}
      onRequestClose={() => {
        closeSlidingPaneDowntimeReasons();
        changeSelected([]);
      }}
    >
      <>
        <Toolbar
          buttons={[
            <AddButton
              tooltipMessage={'organizations.reason'}
              permissions={[unitPermissions.addDowntimeReasons]}
              handleClick={() => {
                changeSelected([]);
                openAddEditDowntimeReasonSlide(true);
              }}
            />,
            <EditButton
              tooltipMessage={'organizations.reason'}
              isDisabled={selected.length < 1}
              permissions={[unitPermissions.editDowntimeReasons]}
              handleClick={() => {
                openAddEditDowntimeReasonSlide(true);
              }}
            />,
            <DeleteButton
              tooltipMessage={'organizations.reason'}
              isDisabled={selected.length < 1}
              permissions={[unitPermissions.removeDowntimeReasons]}
              handleClick={() =>
                alerts.showDeleteConfirmationMessage({
                  action() {
                    dispatch(
                      organizationActions.startRemovingOrganizationDowntimeReason(selected[0])
                    );
                  },
                  objectType: appIntl().formatMessage({ id: 'organizations.reasonToDelete' }),
                  objectName: selected[0].reasonDescription
                })
              }
            />
          ]}
        />
        <Table
          id={'tableDowntimeReasonsScreen'}
          columns={columnInfo}
          data={downtimeReasons}
          selected={selected}
          changeSelected={changeSelected}
          enablePersistence={false}
          isFetching={isFetchingDowntimeReasons}
        />
        <SlidingPaneAddEditDowntimeReason
          downtimeReason={selected[0]}
          organization={organization}
          isOpenSlidingPane={addEditDowntimeReasonSlideOpen}
          closeSlidingPaneAddEditDowntimeReason={(value) => {
            openAddEditDowntimeReasonSlide(false);
            //if (value === true) setExecuteGetDowntimeReasons(!executeGetDowntimeReasons);
          }}
        />
      </>
    </SlidingPane>
  ) : (
    <></>
  );
};

SlidingPaneDowntimeReasons.defaultProps = {};

export default SlidingPaneDowntimeReasons;
